import * as S from './styled'

import { useEffect, useRef, useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { t } from 'i18next'
import api from '@/core/services/api'
import { useAlert } from '@/core/context/useWindow'
import Header from '@/components/common/Header'

export default function GamePlay() {
  const { vendor, id, currency } = useParams()
  const navigate = useNavigate()
  const { openAlert } = useAlert()
  const location = useLocation()
  const iframeRef = useRef(null)
  const [link, setLink] = useState('')

  useEffect(() => {
    if (!id || !vendor || !currency) return
    api.get('/user-game/game-launch-link', {
      params: { game_id: id, vendor, currency }
    })
      .then((res) => {
        const content = res.data?.content
        const gameLink = content?.link || content
        if (gameLink) setLink(gameLink)
      })
      .catch((err) => {
        console.error(err)
        // 점검중 안내(게임사 우선) — 그 외는 기존 메시지
        const code = err.response?.data?.errors?.[0]?.msg?.code
        const msg = code === 'G011' ? t('bet_reject.vendor_maintenance')
          : code === 'G010' ? t('bet_reject.game_maintenance')
            : (err.response?.data?.message || t('error.unknown'))
        // gold 알림 상자로 안내하고, 확인을 누르면 이전 화면으로
        openAlert({ message: msg, Func: () => navigate(-1) })
      })
  }, [id, vendor, currency])

  const handleBack = () => {
    // 게임 목록 페이지(/lobby, 새 창)에서 들어왔으면 그 목록으로 돌아간다.
    // 진입 정보가 없으면(라이브 로비 직행 등) 메인으로 이동.
    const { vendorIndex, category } = location.state || {}
    if (vendorIndex) {
      navigate(`/lobby/${vendorIndex}?category=${category || 'slot'}`)
    } else {
      navigate('/main')
    }
  }

  const handleFullscreen = () => {
    const el = iframeRef.current
    if (!el) return
    if (el.requestFullscreen) el.requestFullscreen()
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen()
    else if (el.msRequestFullscreen) el.msRequestFullscreen()
  }

  const handleNewWindow = () => {
    if (link) window.open(link, '_blank', 'noopener,noreferrer')
  }

  return (
    <>
      <Header />
      <S.Wrap>
        <S.TopBar>
          <S.Controls>
            <S.ControlBtn onClick={handleNewWindow} title="New Window">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" />
              </svg>
            </S.ControlBtn>
            <S.ControlBtn onClick={handleFullscreen} title="Fullscreen">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3" />
              </svg>
            </S.ControlBtn>
          </S.Controls>
          <S.BackBtn onClick={handleBack}>← {t('button.back')}</S.BackBtn>
        </S.TopBar>
        {link && (
          <S.GameFrame
            ref={iframeRef}
            src={link}
            allowFullScreen
            allow="autoplay; fullscreen"
          />
        )}
      </S.Wrap>
    </>
  )
}
